/* eslint-disable no-new */
import confetti from 'canvas-confetti';
import accordion from './accordion';
import signUpFlow from './signup-flow';
import toggleDisabled from './toggle-disabled';
import videoPlayer from './video-player';
import Lightbox from './lightbox';
import StickyObserver from './sticky-observer';
import VisibilityToggle from './visibility-toggle';
import TextareaCodemirror from './textarea-codemirror';
import TextareaCounter from './textarea-counter';
import TextareaTip from './textarea-tip';
import CreateProject from './create-project';
import WizardFormSubmit from './wizard-form-submit';
import Ping from './ping';
import AsyncForm from './async-form';
import AvatarCrop from './avatar-crop';
import PreviewUpload from './preview-upload';
import UrlPrefixer from './url-prefixer';
import ViewToggle from './view-toggle';
import SuggestedSearch from './suggested-search';
import OrganizationMedia from './organization-media';
import MagicTabsBox from './magic-tabs-box';
import UmbracoAutomation from './umbraco-automation';
import Segment from './segment';
import ClipboardCopy from './clipboard-copy';
import ProgressBar from './progress-bar';
import ScrollIntoView from './scoll-into-view';
import Counter from './counter';
import Toggle from './toggle';
import Slider from './slider';
import ReadMoreToggle from './read-more-toggle';
import ProfessionalJourney from './professional-journey';
import ReviewPoke from './review-poke';
import ExitPopup from './exit-popup';
import InfoSlider from './info-slider';
import CommunicationPreferences from './communication-preferences';
import FormHelpers from './form-helpers';
import OnboardingFlow from './onboarding';
import MissingInputCheck from './missing-input';
import OnSelectFilter from './on-select-filter';
import PopUpOnLoad from './popup-on-load';
import UrlQueryPageLoad from './url-query-page-load';
import AddFavourite from './add-favourite';
import ProjectFavourite from './project-favourite';
import CheckRetrievedItemsFromSession from './check-session-storage-items';
import Analytics from './analytics';
import ReversedTextareaCounter from './reversed-textarea-counter';
import errorHandling from './error-handling';
import ContactLogin from './contact-login';
import OnIndexSelectToggle from './select-toggle-block';
import BlockListRemoval from './block-list-removal';
import DeleteMember from './delete-member';
import ProfessionalLogin from './professional-login';
import HubspotCheck from './hubspot-check';
import ValidateForm from './validate-form';
import IntlTelInput from './intl-tel-input';
import ExternalSignIn from './external-sign-in';
import Autofocus from './autofocus';

accordion.init();
toggleDisabled.init();
videoPlayer.init();
Analytics.init();

if (document.getElementById('signUpForm')) {
	signUpFlow.init();
}

if (document.getElementById('urlQueryPageLoad')) {
	UrlQueryPageLoad.init({ el: document.getElementById('urlQueryPageLoad') });
}

// TODO: Move volunteering status pop-up to communication preferences and make generic
if (document.getElementById('VolunteeringStatus')) {
	CommunicationPreferences.init({ element: document.getElementById('VolunteeringStatus') });
}

if (document.querySelectorAll('[data-add-favourite]').length > 0) {
	new AddFavourite({ elements: document.querySelectorAll('[data-add-favourite]') });
}

if (document.querySelectorAll('[data-project-favourite]').length > 0) {
	new ProjectFavourite({ elements: document.querySelectorAll('[data-project-favourite]') });
}

if (document.getElementById('onSelectFilter')) {
	OnSelectFilter.init({ elements: document.getElementById('onSelectFilter') });
}

if (document.getElementById('UpdateOrganizationMediaForm')) {
	OrganizationMedia.init({ form: document.getElementById('UpdateOrganizationMediaForm') });
}

if (document.querySelectorAll('[data-suggested-search]').length > 0) {
	new SuggestedSearch({ elements: document.querySelectorAll('[data-suggested-search]') });
}

if (document.querySelectorAll('[data-autofocus]').length > 0) {
	new Autofocus({ elements: document.querySelectorAll('[data-autofocus]') });
}

if (document.getElementById('viewSelector')) {
	ViewToggle.init({ element: document.getElementById('viewSelector') });
}

if (document.getElementById('onboardingFlow')) {
	OnboardingFlow.init({ element: document.getElementById('onboardingFlow') });
}

if (document.querySelectorAll('input[type="url"]')) {
	new UrlPrefixer({ elements: document.querySelectorAll('input[type="url"]') });
}

if (document.querySelectorAll('[data-upload-preview]').length > 0) {
	new PreviewUpload({ elements: document.querySelectorAll('[data-upload-preview]') });
}

if (document.getElementById('upload')) {
	new AvatarCrop(document.getElementById('upload'));
}

if (document.getElementById('CreateProjectForm')) {
	CreateProject.init({ form: document.getElementById('CreateProjectForm') });
}

if (document.getElementById('WizardForm')) {
	WizardFormSubmit.init({ form: document.getElementById('WizardForm') });
}

// TODO: conditional
Array.from(document.querySelectorAll('[data-component]')).forEach((lightbox) => {
	new Lightbox({ element: lightbox });
});

if (document.querySelectorAll('[data-observable]').length > 0) {
	new StickyObserver({ elements: document.querySelectorAll('[data-observable]') });
}

new Ping();

if (document.querySelectorAll('[data-visibility-toggle]').length > 0) {
	new VisibilityToggle({ elements: document.querySelectorAll('[data-visibility-toggle]') });
}

if (document.querySelectorAll('[data-toggle]').length > 0) {
	new Toggle({ elements: document.querySelectorAll('[data-toggle]') });
}

if (document.querySelectorAll('[data-async-form]').length > 0) {
	new AsyncForm({ elements: document.querySelectorAll('[data-async-form]') });
}

if (document.querySelectorAll('[data-textarea-counter]').length > 0) {
	new TextareaCounter({ elements: document.querySelectorAll('[data-textarea-counter]') });
}

if (document.querySelectorAll('[data-reversed-textarea-counter]').length > 0) {
	new ReversedTextareaCounter({
		elements: document.querySelectorAll('[data-reversed-textarea-counter]'),
	});
}

if (document.querySelectorAll('[data-codemirror]').length > 0) {
	new TextareaCodemirror({ elements: document.querySelectorAll('[data-codemirror]') });
}

if (document.querySelectorAll('[data-textarea-tip]').length > 0) {
	new TextareaTip({ elements: document.querySelectorAll('[data-textarea-tip]') });
}

if (document.querySelectorAll('[data-magic-tab]').length > 0) {
	new MagicTabsBox({ elements: document.querySelectorAll('[data-magic-tab]') });
}

if (document.getElementById('umbracoAutomation')) {
	UmbracoAutomation.init({ element: document.getElementById('umbracoAutomation') });
}

if (document.querySelectorAll('[data-segment]').length > 0) {
	new Segment({ elements: document.querySelectorAll('[data-segment]') });
}

if (document.querySelectorAll('[data-counter]').length > 0) {
	new Counter({ elements: document.querySelectorAll('[data-counter]') });
}

if (document.querySelectorAll('[data-progress-bar]').length > 0) {
	new ProgressBar({ elements: document.querySelectorAll('[data-progress-bar]') });
}

if (document.querySelectorAll('[data-clipboard-copy]').length > 0) {
	new ClipboardCopy({ elements: document.querySelectorAll('[data-clipboard-copy]') });
}

if (document.querySelectorAll('[data-scroll-into-view]').length > 0) {
	new ScrollIntoView({ elements: document.querySelectorAll('[data-scroll-into-view]') });
}

if (document.querySelectorAll('[data-carousel]').length > 0) {
	new Slider({ elements: document.querySelectorAll('[data-carousel]') });
}

if (document.querySelectorAll('[data-on-index-select-toggle]').length > 0) {
	new OnIndexSelectToggle({
		elements: document.querySelectorAll('[data-on-index-select-toggle]'),
	});
}

if (document.getElementById('professionalJourney')) {
	new ProfessionalJourney();
}

if (document.getElementById('popUpOnLoad')) {
	new PopUpOnLoad({ el: document.getElementById('popUpOnLoad') });
}

if (document.querySelectorAll('[data-send-poke]').length > 0) {
	new ReviewPoke({ elements: document.querySelectorAll('[data-send-poke]') });
}

if (document.querySelectorAll('[data-read-more]').length > 0) {
	new ReadMoreToggle({ elements: document.querySelectorAll('[data-read-more]') });
}

if (document.querySelector('[data-exit-popup]')) {
	new ExitPopup({ element: document.querySelector('[data-exit-popup]') });
}

if (document.querySelectorAll('[data-info-slider]').length > 0) {
	new InfoSlider({ elements: document.querySelectorAll('[data-info-slider]') });
}

if (document.querySelectorAll('[data-validate-image]').length > 0) {
	Array.from(document.querySelectorAll('[data-validate-image]')).forEach((imageUploadElement) => {
		imageUploadElement.addEventListener('change', () => {
			FormHelpers.validateImageUploadExtension(imageUploadElement);
		});
	});
}

if (document.querySelectorAll('[data-validate-file]').length > 0) {
	Array.from(document.querySelectorAll('[data-validate-file]')).forEach((fileUploadElement) => {
		fileUploadElement.addEventListener('change', () => {
			FormHelpers.validateImageUploadExtension(fileUploadElement);
		});
	});
}

if (document.querySelectorAll('.wizard__fiedset').length === 0) {
	FormHelpers.validateImageUploadExtension(document);
}

if (document.querySelectorAll('[data-hubspot-check]').length > 0) {
	new HubspotCheck();
}

if (document.querySelectorAll('[data-validate-form]').length > 0) {
	new ValidateForm({ elements: document.querySelectorAll('[data-validate-form]') });
}

if (document.getElementById('applyBtn')) {
	const applyBtn = document.getElementById('applyBtn');
	applyBtn.addEventListener('click', (e) => {
		e.preventDefault();
		const el = document.getElementById('applyForm');
		const missingInputElements = document.querySelectorAll('[data-missing-input]');
		const validationElements = document.querySelectorAll('[data-validation]');

		if (missingInputElements.length > 0) {
			MissingInputCheck.checkMissingInput(el, e);
		} else if (validationElements.length > 0) {
			// apply button is disabled by default, so it gets enabled if there is an wrong input (since the user can't otherwise submit the form)
			applyBtn.disabled = false;
			if (errorHandling(validationElements)) {
				// if the input is correct, disable the button again
				applyBtn.disabled = true;
				el.submit();
			}
		} else {
			el.submit();
		}
	});
}

if (document.querySelectorAll('[data-external-sign-in]').length > 0) {
	new ExternalSignIn({ elements: document.querySelectorAll('[data-external-sign-in]') });
}

if (document.getElementById('jobboardApplyForm')) {
	const applyBtn = document.getElementById('jobboardApplyBtn');
	const el = document.getElementById('jobboardApplyForm');
	const validationElements = document.querySelectorAll('[data-validation]');
	const cvUpload = document.getElementById('Cv');
	const linkedInProfile = document.getElementById('LinkedInProfile');
	const cvLinkedInError = document.getElementById('CVLinkedInError');
	applyBtn.addEventListener('click', (e) => {
		e.preventDefault();

		if (linkedInProfile && linkedInProfile.value === '' && cvUpload && cvUpload.value === '') {
			cvLinkedInError.classList.remove('error-msg--hidden');
		} else if (errorHandling(validationElements)) {
			el.submit();
		}
	});
}

if (document.querySelectorAll('[data-checkbox-limit-check]').length > 0) {
	document.querySelectorAll('[data-checkbox-limit-check]').forEach((el) => {
		const checkboxes = el.querySelectorAll('input[type="checkbox"]');
		const checkedCheckboxesAmount = el.querySelectorAll('input[type="checkbox"]:checked').length;
		FormHelpers.checkboxLimit(
			checkboxes,
			checkedCheckboxesAmount,
			el.dataset?.limit,
			el.querySelector('.checkbox-limit__message'),
			el.dataset?.allowedMoreThanLimit
		);
	});
}

if (document.querySelectorAll('[data-professional-login]').length > 0) {
	new ProfessionalLogin({ elements: document.querySelectorAll('[data-professional-login]') });
}

// TODO: Move this code to module
if (document.querySelectorAll('[data-show-confetti]').length > 0) {
	// do this for 3 seconds
	const end = Date.now() + 3 * 1000;

	const interval = setInterval(() => {
		if (Date.now() > end) {
			return clearInterval(interval);
		}

		return confetti({
			startVelocity: 30,
			spread: 360,
			ticks: 60,
			shapes: ['square'],
			origin: {
				x: Math.random(),
				// since they fall down, start a bit higher than random
				y: Math.random() - 0.2,
			},
		});
	}, 200);
}

if (document.querySelectorAll('[data-session-items-check]').length > 0) {
	new CheckRetrievedItemsFromSession({
		elements: document.querySelectorAll('[data-session-items-check]'),
	});
}

if (document.querySelectorAll('[data-delete-item]').length > 0) {
	new BlockListRemoval({
		elements: document.querySelectorAll('[data-delete-item]'),
	});
}

if (document.querySelectorAll('[data-contact-login]').length > 0) {
	new ContactLogin({
		elements: document.querySelectorAll('[data-contact-login]'),
	});
}

if (document.querySelectorAll('[data-delete-member]').length > 0) {
	new DeleteMember({
		elements: document.querySelectorAll('[data-delete-member]'),
	});
}

if (document.getElementById('phoneNumberInput')) {
	new IntlTelInput({ element: document.getElementById('phoneNumberInput') });
}
